import {
  PRODUCT_TYPE_CAMERA,
  PRODUCT_TYPE_KIT,
} from "@/app/blu/shop/constants";
import { isProduction } from "@/utils/env.util";

export const BAZAARVOICE_SCRIPT_URL = isProduction
  ? "https://apps.bazaarvoice.com/deployments/adt/main_site/production/en_US/bv.js"
  : "https://apps.bazaarvoice.com/deployments/adt/main_site/staging/en_US/bv.js";

export const BAZAARVOICE_ORIGIN = "https://apps.bazaarvoice.com";

/** Product types eligible for the Bazaarvoice inline rating widget on PLP tiles. */
export const BV_INLINE_RATING_PRODUCT_TYPES: readonly string[] = [
  PRODUCT_TYPE_CAMERA,
  PRODUCT_TYPE_KIT,
];
